export const TAGS_DATA_KEYS = {
    alignment: 'data-alignment',
    skin: 'data-skin',
    size: 'data-size',
    rtl: 'data-rtl',
    index: 'data-tag-index',
    tagIsChecked: 'data-tag-checked',
};
//# sourceMappingURL=dataHooks.js.map